import {SharedModule} from '../../../shared/shared.module';
import {PartenairesListComponent} from './partenaires-list.component';
import { PartenairesListResolver } from './partenaires-list.resolver';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';

@NgModule({
  imports: [
    NgbModule,
    DataTableModule,
    SharedModule
  ],
  declarations: [PartenairesListComponent],
  exports: [PartenairesListComponent],
  providers: [PartenairesListResolver]
})
export class PartenairesListModule {

}
